export default __webpack_public_path__ + "static/media/T11.11b9ed7b.png";